export default __webpack_public_path__ + "static/media/no_image.87d79d59.jpg";